import { selectMyProfileData } from './ProfileService';

export const getLuxIdActorParameter = (): string | undefined => {
    const profileData = selectMyProfileData();

    if (!profileData) {
        return undefined;
    }

    if (profileData.customerId) {
        // mandatory for retail, optional for business
        return profileData.customerId;
    }

    if (profileData.userNumber) {
        // mandatory for business, optional for retail
        return profileData.userNumber;
    }

    return undefined;
};
